import FaqResults from './faq-results';

export default FaqResults;
